import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { FC } from 'react';

import BoostModalContent from '@features/boostMyJobs/components/BoostModalContent/BoostModalContent';
import BoostNote from '@features/boostMyJobs/components/BoostNote/BoostNote';
import { Close } from '@mui/icons-material';
import RocketLaunchOutlinedIcon  from '@mui/icons-material/RocketLaunchOutlined';
type BoostModalProps = {
  isOpen: boolean;
  selectedCompanyId?: string | number;
  handleClose: () => void;
  handleRequestSocialClick: () => void;
  handleRequestLocationClick: () => void;
  handlePostToSocialMedia: () => void;
};

const BoostModal: FC<BoostModalProps> = ({
  isOpen,
  handleClose,
  handleRequestSocialClick,
  handleRequestLocationClick,
  handlePostToSocialMedia,
  selectedCompanyId,
}) => (
  <Dialog open={isOpen} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <IconButton
          sx={{ position: 'absolute', top: 5, right: 5 }}
          onClick={handleClose}
        >
          <Close />
        </IconButton>
        <br />
        <RocketLaunchOutlinedIcon
          sx={{
            fontSize: 60,
            color: 'primary.main',
            margin: 'auto !important',
          }}
        />
        <Typography variant="h3" sx={{ pt: 3 }}>
          Boost your jobs!*
        </Typography>
      </DialogTitle>
    <DialogContent
      sx={{
        textAlign: 'center',
      }}
    >
      <Stack spacing={5} sx={{marginBottom: 5}}>
        <BoostModalContent
          handleRequestSocialClick={handleRequestSocialClick}
          handleRequestLocationClick={handleRequestLocationClick}
          handlePostToSocialMediaClick={handlePostToSocialMedia}
          selectedCompanyId={selectedCompanyId}
        />
        <BoostNote />
      </Stack>
    </DialogContent>
  </Dialog>
);

export default BoostModal;
